import { gcApi } from 'config/axios';
import { takeEvery, call, put } from 'redux-saga/effects';

import {
    FETCH_FTP,
    FETCH_FTP_FETCHING,
    FETCH_FTP_SUCCESS,
    FETCH_FTP_FAIL,
    FETCH_POWER_TO_WEIGHT,
    FETCH_POWER_TO_WEIGHT_FETCHING,
    FETCH_POWER_TO_WEIGHT_SUCCESS,
    FETCH_POWER_TO_WEIGHT_FAIL
} from '../actions/ActionTypes';

// Workers
export function* fetchFTP(action) {
    try {
        const {
            payload: { startDate, endDate, aggregation, sport }
        } = action;

        yield put({
            type: FETCH_FTP_FETCHING
        });

        const response = yield call(
            gcApi.get,
            `/biometric-service/stats/functionalThresholdPower/range/${startDate}/${endDate}`,
            {
                params: {
                    aggregation,
                    ...(sport !== 'all' && { sport })
                }
            }
        );

        yield put({
            type: FETCH_FTP_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_FTP_FAIL
        });
    }
}

export function* fetchPowerToWeight(action) {
    try {
        const {
            payload: { startDate, endDate, aggregation, sport }
        } = action;

        yield put({
            type: FETCH_POWER_TO_WEIGHT_FETCHING
        });

        const response = yield call(gcApi.get, `/biometric-service/stats/powerToWeight/range/${startDate}/${endDate}`, {
            params: {
                aggregation,
                ...(sport !== 'all' && { sport })
            }
        });

        yield put({
            type: FETCH_POWER_TO_WEIGHT_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_POWER_TO_WEIGHT_FAIL
        });
    }
}

// Watchers
export const ftpRangeSagas = [takeEvery(FETCH_FTP, fetchFTP), takeEvery(FETCH_POWER_TO_WEIGHT, fetchPowerToWeight)];
